import React, { useState, useEffect } from 'react';
import SummaryDisplay from '../../MicroProbe//Companies/SummaryDisplayNews';
import { newsSummary } from '../../../../services/newsSummary';

const EconomyHighlight = ({ inputData }) => {
    const [keyword, setKeyword] = useState('');
    const [summaryData, setSummaryData] = useState(null);
    const [isLoadingSummary, setIsLoadingSummary] = useState(false); 

    useEffect(() => {
        setKeyword(`${inputData.name} economy`);
    }, [inputData]);

    const fetchSummary = async () => {
        setIsLoadingSummary(true); 
        setSummaryData(null); 
        try {
            const summary = await newsSummary(keyword); 
            setSummaryData(summary); 
        } catch (error) {
            console.error('Failed to fetch analysis:', error);
        }
        setIsLoadingSummary(false); 
    }

    const handleSearchClick = () => {
        fetchSummary();
    }

    const isLoading = isLoadingSummary;

    return (
        <div>
        <h3>Economy</h3>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: '10px' }}>
                <button onClick={handleSearchClick}>Highlights</button>
                {isLoading && <div>Thinking, please wait…</div>}
         
                {summaryData && <SummaryDisplay summary={summaryData.response} />}
              
               
            </div>
        </div>
    );
}

export default EconomyHighlight;